import React, { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import { host } from "../../config/Config";
import img from "../../resources/banner.jpeg";

export const Banner = () => {
    const [appointmentsData, setDateTimeData] = React.useState([]);
    const navigate = useNavigate();
    const [isLoaded, setIsLoaded] = useState(false);
    const [language, setLanguage] = useState("10");
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
      const storedLanguage = localStorage.getItem("selectedLanguage");
      if (storedLanguage) {
          setLanguage(storedLanguage);
      }

      const handleStorageChange = () => {
          setLanguage(localStorage.getItem("selectedLanguage") || "10");
          setIsLoggedIn(localStorage.getItem("zajednica-token") || localStorage.getItem("jwt-vlada"));
      };

      window.addEventListener("storage", handleStorageChange);
      setIsLoggedIn(localStorage.getItem("zajednica-token") || localStorage.getItem("jwt-vlada"));

      let isMounted = true;
      setIsLoaded(true);
    
      fetch(`${host}/api/v1/appointments/available`)
        .then((response) => response.json())
        .then((data) => {
          if (isMounted) {
            const updatedAppointments = {};
    
            data.forEach(item => {
              const startDate = new Date(item.startTime);
              const endDate = new Date(item.endTime);
    
              const formattedDate = `${startDate.getDate().toString().padStart(2, '0')}.${(startDate.getMonth() + 1).toString().padStart(2, '0')}.${startDate.getFullYear()}.`;
    
              const formattedTime = `${startDate.toLocaleTimeString("en-GB", { hour: '2-digit', minute: '2-digit' })} - ` +
                                    `${endDate.toLocaleTimeString("en-GB", { hour: '2-digit', minute: '2-digit' })}`;
    
              if (!updatedAppointments[formattedDate]) {
                updatedAppointments[formattedDate] = [];
              }
              updatedAppointments[formattedDate].push(formattedTime);
            });
    
            setDateTimeData(updatedAppointments);
          }
        })
        .catch((error) => console.error('Error fetching available-appointments', error));
    
      return () => {
        isMounted = false;
      };
    }, []);
    

    const HandleClick = () => {
        navigate('/reservation', {
            state : {
                appointmentsData
            }
        })
    }

    const HandleLogin = () => {
      navigate('/registration', {
        state : {
            appointmentsData
        }
    })
    }

    const HandleProfile = () => {
      if (localStorage.getItem("jwt-vlada")) {
        navigate('/admin')
      } else {
        navigate('/profile', {
          state : {
              appointmentsData
          }
      })
      }
    }

    return (
        <div>
            <img 
                src={img}
                alt="Banner"
                className={`image-fade-in ${isLoaded ? 'fade-in' : ''}`}
            />
            <div className={`text-overlay ${isLoaded ? 'fade-in' : ''}`}>
                {language == 20 ? 'Welcome' : 'Dobrodošli'}
            </div>
            <div className={`text-overlay-zajednica ${isLoaded ? 'fade-in' : ''}`}>
                {language == 20 ? 'Barber Zajednica' : 'Barber Zajednica'}
            </div>
            <div 
                onClick={HandleClick}
                className={`text-overlay-button ${isLoaded ? 'fade-in' : ''}`}> 
                  {language == 20 ? 'Reserve Appointment' : 'Rezerviši termin'}
            </div>
            <div 
                onClick={isLoggedIn ? HandleProfile : HandleLogin} 
                className={`text-overlay-button-login ${isLoaded ? "fade-in" : ""}`}> 
                {language == 20 ? (isLoggedIn ? "My Profile" : "Registration") : (isLoggedIn ? "Moj Profil" : "Registracija")}
            </div>
        </div>
    );
}